export default class ImagePlaceholder {
    constructor () {
        window.addEventListener('DOMContentLoaded',  this.init.bind(this))
    }

    init () {
        const images = document.querySelectorAll('.post-content img')
        for (const image of images) {
            image.onerror = () => {
                if (!this.isValidImage(image)) {
                    image.src = GLOBALS.assets_dir + '/images/no-image.png'
                    image.removeAttribute('srcset')
                    image.classList.add('no-image')
                }
            }
        }
    }

    isValidImage (img) {
        if (!img.complete) {
            return false
        }
        if (typeof img.naturalWidth != 'undefined' && img.naturalWidth == 0) {
            return false
        }
        return true
    }
}

